import { useEffect, useState } from "react";
import {
  HeaderWrapper,
  HeaderContainer,
  Brand,
  NavLinks,
  HeaderLink,
  MenuToggle,
  Overlay,
} from "./header.styles";

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 767) setIsOpen(false);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function handleNavigate() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setIsOpen(false);
  }

  return (
    <HeaderWrapper>
      <HeaderContainer>
        <Brand to="/" onClick={handleNavigate}>
          Topilov.
        </Brand>
        <NavLinks $isOpen={isOpen}>
          <HeaderLink onClick={handleNavigate} to="/">
            <span>HOME</span>
          </HeaderLink>
          <HeaderLink onClick={handleNavigate} to="/work">
            <span>PROJECTS</span>
          </HeaderLink>
          {/* <HeaderLink onClick={handleNavigate} to="/certificates">
            <span>AWARDS</span>
          </HeaderLink> */}
          <HeaderLink onClick={handleNavigate} to="/contact">
            <span>CONTACT</span>
          </HeaderLink>
        </NavLinks>
        <MenuToggle
          type="button"
          $isOpen={isOpen}
          aria-label="Toggle menu"
          aria-expanded={isOpen}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <span />
          <span />
          <span />
        </MenuToggle>
      </HeaderContainer>
      <Overlay $isOpen={isOpen} onClick={() => setIsOpen(false)} />
    </HeaderWrapper>
  );
}

export default Header;
